import {Component} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {NachreichungAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-nachreichung-angaben',
  templateUrl: './nachreichung-angaben.component.html'
})
export class NachreichungAngabenComponent extends WizardPageBaseComponent<NachreichungAngaben> {

  static nutzdatenPath = 'nachreichungAngaben';
  static route = 'nachreichung-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([]);
  }
}
